import Image from 'next/image'

import { Button } from '@wartek-id/button'

const MaintenanceInfo = () => {
  return (
    <div className="h-full flex items-center justify-center px-4">
      <div>
        <Image
          src="https://storage.googleapis.com/microlearning-public-production/web-assets/img-error-fixing.png"
          height={120}
          width={120}
          alt="maintenance"
          className="mb-4"
        />
        <div className="font-semibold text-lg">Maaf, sedang ada gangguan</div>
        <p className="text-sm text-gray-60 mb-4">
          Tak perlu khawatir, tim kami sedang menanganinya. Mohon coba lagi
          nanti.
        </p>
        <Button
          onClick={() => window.location.reload()}
          className="mt-2"
          fullWidth
          color="black"
        >
          Coba lagi
        </Button>
      </div>
    </div>
  )
}

export default MaintenanceInfo
